/**
 * viewmodel参数配置表
 * 对画图基本context基本样式做修改
 */
import Hammer from 'hammerjs';
import Util, { mergeOption } from '../util/index.js';
import { ERROR_TYPE } from './setting.js';
const familyM = "'PingFangSC-Medium', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'";
const familyR = "'PingFangSC-Regular', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'";
const sizeRatio = 1;
const marginSpace = 0; // 去掉原本保留的边距
export const Conf = {
  /*** 画布组件 ***/
  Component: {
    /**
     * 设置top和bottom用以上下分割canvas
     * 若要设置context的有效绘图区域
     * 可在MainContext和FootContext里设置
     */
    mainViewOption: {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0.3
    },
    mainFullViewOption: {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0.332
    },
    footViewOption: {
      left: 0,
      top: 0.7,
      right: 0,
      bottom: 0
    },
    footFullViewOption: {
      left: 0,
      top: 0.668,
      right: 0,
      bottom: 0
    },
    errorMsg: {
      sizeRatio: sizeRatio,
      type: ERROR_TYPE.ERROR_TEXT,
      fontFamily: 'Arial',
      color: '#000',
      value: 'No Data'
    },
    supportHammer: true,
    hammerOption: {
      panAble: true,
      pan: {
        direction: Hammer.DIRECTION_HORIZONTAL
      },
      pressAble: true,
      tapAble: true,
      pinchAble: true
    }
  },
  /*** 上下文基类 ***/
  BaseContext: {
    spaceRatio: 0.3,
    colorMap: [
      // '#52CC7A', // 跌2ab447原
      '#2ab447', // 跌 现
      '#EF4342', // 涨
      // "#E64595", //
      // "#FF3737", //
      // "#71ADFD", //
      // "#5AB76B", //
      '#42B957',
      '#F26968'
    ]
  },
  /*** 主视图 ***/
  MainContext: {
    dashColor: '#DCDCDC',
    solidColor: '#DCDCDC',
    gridLine: 'solid', // 分隔线类型
    size: {
      top: 0.12,
      bottom: 0,
      left: marginSpace,
      right: marginSpace,
    },
    fullSize: {
      top: 0.15,
      bottom: 0,
      left: marginSpace,
      right: marginSpace,
    },
    label: {
      spaceX: 5,
      spaceY: 2,
      radius: 2,
      sizeRatio: sizeRatio,
      fontFamily: familyM,
      lineWidth: 0.3,
      color: '#ffffff',
      backColor: '#bcbcbc'
    },
    ball: {
      show: true,
      innerBall: {
        radius: 5,
        backColor: 'rgba(104,142,217,1)',
      },
      outerBall: {
        radius: 10,
        backColor: 'rgba(104,142,217)',
        maxOpacity: 0.4
      },
      duration: 2
    },
    crossPoint: {
      show: true,
      radius: 5,
      lineWidth: 1,
      color: '#969696',
      backColor: '#ffffff'
    },
    title: {
      baseLine: 0.04
    },
    tips: {
      fontFamily: familyM,
      sizeRatio: sizeRatio,
      color: '#797979',
      defaultText: '延时15分钟'
    },
    /** @type {Object} [X轴时间配置参数] */
    axisX: {
      top: 0.68,
      sizeRatio: sizeRatio,
      fontFamily: familyM,
      color: '#969696'
    },
  },
  /*** 辅视图 ***/
  FootContext: {
    dashColor: '#DCDCDC',
    solidColor: '#DCDCDC',
    size: {
      top: 0.20, //向上距离主视图的距离
      bottom: 0,
      left: marginSpace,
      right: marginSpace,
    },
    fullSize: {
      top: 0.2,
      bottom: 0.22,
      left: marginSpace,
      right: marginSpace,
    },
    label: {
      spaceX: 5,
      spaceY: 2,
      radius: 2,
      sizeRatio: sizeRatio,
      top: 0.03,
      fontFamily: familyM,
      lineWidth: 0.3,
      color: '#ffffff',
      backColor: '#bcbcbc'
    },
    /** @type {Object} [X轴时间配置参数] */
    axisX: {
      // 横坐标时间线原在辅视图下，现改为在主视图下
      // top: 0.68,
      top: 0.03,
      sizeRatio: sizeRatio,
      fontFamily: familyM,
      color: '#969696'
    },
    fullAxisX: {
      top: 0.79,
      sizeRatio: sizeRatio,
      fontFamily: familyM,
      color: '#969696'
    },
    title: {
      baseLine: 0
    }
  },
  /*** 分时 ***/
  Trend: {
    // 最新均价title
    title: {
      color: '#969696',
      sizeRatio: sizeRatio,
      fontFamily: familyM,
      space: 10,
      textSpace: 5,
    },
    avgLine: {
      lineWidth: 1,
      color: '#FDC42B'
    },
    lastLine: {
      lineWidth: 1,
      color: '#6C79FC'
    },
    gridentColor: {
      0: "rgba(122,162,245,0.2)",
      1: "rgba(122,162,245,0)"
    },
    axisY: {
      sizeRatio: sizeRatio,
      fontFamily: familyM,
      color: '#999999'
    }
  },
  /*** K线 ***/
  KLine: {
    axisY: {
      sizeRatio: sizeRatio,
      fontFamily: familyM,
      color: '#969696'
    },
    // 收盘价折线图和面积图配置
    closePx: {
      closeLine: {
        lineWidth: 1,
        color: '#3896FF'
      },
      gridentColor: {
        0: "rgba(122,162,245,0.2)",
        1: "rgba(122,162,245,0)"
      },
      sizeRatio: sizeRatio,
      fontFamily: familyM,
      color: '#3896FF',
      space: 6
    }
  },
  /*** MACD ***/
  Macd: {
    axisY: {
      sizeRatio: sizeRatio,
      color: 'rgba(0,0,0,0.6)',
      fontFamily: familyM
    },
    params: {
      color: '#999',
      index: 'MACD(12,26,9)'
    },
    dif: {
      lineWidth: 1,
      color: '#3896FF'
    },
    dea: {
      lineWidth: 1,
      color: "#F95EB8"
    },
    sizeRatio: sizeRatio,
    fontFamily: familyM,
    space: 6
  },
  Dma: {
    axisY: {
      sizeRatio: sizeRatio,
      color: 'rgba(0,0,0,0.6)',
      fontFamily: familyM
    },
    params: {
      color: '#999',
      index: 'DMA(10,50,10)'
    },
    dif: {
      lineWidth: 1,
      color: "#3896FF"
    },
    difma: {
      lineWidth: 1,
      color: '#F95EB8'
    },
    sizeRatio: sizeRatio,
    fontFamily: familyM,
    space: 6
  },
  Vr: {
    axisY: {
      sizeRatio: sizeRatio,
      color: 'rgba(0,0,0,0.6)',
      fontFamily: familyM
    },
    params: {
      color: '#999',
      index: 'VR(26,6)'
    },
    vr: {
      lineWidth: 1,
      color: '#3896FF'
    },
    mavr: {
      lineWidth: 1,
      color: '#FF60F6'
    },
    sizeRatio: sizeRatio,
    fontFamily: familyM,
    space: 6

  },
  Rsi: {
    axisY: {
      sizeRatio: sizeRatio,
      color: 'rgba(0,0,0,0.6)',
      fontFamily: familyM
    },
    params: {
      color: '#999',
      index: 'RSI(6,12,24)'
    },
    rsi6: {
      lineWidth: 1,
      color: '#3896FF'
    },
    rsi12: {
      lineWidth: 1,
      color: '#F95EB8'
    },
    rsi24: {
      lineWidth: 1,
      color: '#FF8A00'
    },
    sizeRatio: sizeRatio,
    fontFamily: familyM,
    space: 6
  },
  Psy: {
    axisY: {
      sizeRatio: sizeRatio,
      color: 'rgba(0,0,0,0.6)',
      fontFamily: familyM
    },
    params: {
      color: '#999',
      index: 'PSY(12,6)'
    },
    psy: {
      lineWidth: 1,
      color: '#3896FF'
    },
    psyMa: {
      lineWidth: 1,
      color: '#FF60F6'
    },
    sizeRatio: sizeRatio,
    fontFamily: familyM,
    space: 6
  },
  Dmi: {
    axisY: {
      sizeRatio: sizeRatio,
      color: 'rgba(0,0,0,0.6)',
      fontFamily: familyM
    },
    params: {
      color: '#999',
      index: 'DMI(14,6)'
    },
    pdi: {
      lineWidth: 1,
      color: '#3896FF'
    },
    mdi: {
      lineWidth: 1,
      color: '#F95EB8',
    },
    adx: {
      lineWidth: 1,
      color: '#FF8A00'
    },
    adxr: {
      lineWidth: 1,
      color: '#00BE00'
    },
    sizeRatio: sizeRatio,
    fontFamily: familyM,
    space: 6

  },
  Obv: {
    axisY: {
      sizeRatio: sizeRatio,
      color: 'rgba(0,0,0,0.6)',
      fontFamily: familyM
    },
    params: {
      color: "#999",
      index: 'OBV(30)'
    },
    obv: {
      lineWidth: 1,
      color: '#3896FF'
    },
    maobv: {
      lineWidth: 1,
      color: "#F95EB8"
    },
    sizeRatio: sizeRatio,
    fontFamily: familyM,
    space: 6



  },
  Wr: {
    axisY: {
      sizeRatio: sizeRatio,
      color: 'rgba(0,0,0,0.6)',
      fontFamily: familyM
    },
    params: {
      color: '#999',
      index: 'WR(10,6)'
    },
    wr6: {
      lineWidth: 1,
      color: '#3896FF'
    },
    wr10: {
      lineWidth: 1,
      color: "#F95EB8"
    },
    sizeRatio: sizeRatio,
    fontFamily: familyM,
    space: 6
  },
  /*** 资金博弈 ***/
  FundFlowCapital: {
    axisY: {
      sizeRatio: sizeRatio,
      color: 'rgba(0,0,0,0.6)',
      fontFamily: familyM
    },
    topText: {
      text: '资金博弈',
      sizeRatio: sizeRatio,
      color: 'rgba(0,0,0,0.6)',
      fontFamily: familyM
    },
    superLine: {
      text: '超',
      lineWidth: 1,
      color: '#E64595',
      sizeRatio: sizeRatio,
      fontFamily: familyM
    },
    largeLine: {
      text: '大',
      lineWidth: 1,
      color: "#FF4646",
      sizeRatio: sizeRatio,
      fontFamily: familyM
    },
    mediumLine: {
      text: '中',
      lineWidth: 1,
      color: '#FF9900',
      sizeRatio: sizeRatio,
      fontFamily: familyM
    },
    littleLine: {
      text: '小',
      lineWidth: 1,
      color: "#688ED9",
      sizeRatio: sizeRatio,
      fontFamily: familyM
    }
  },
  /*** 资金流向 ***/
  FundFlowDirection: {
    fundflowLine: {
      lineWidth: 1,
      color: "red",
      sizeRatio: sizeRatio,
      fontFamily: familyM
    },
    axisY: {
      sizeRatio: sizeRatio,
      color: 'rgba(0,0,0,0.6)',
      fontFamily: familyM
    },
    topText: {
      text: '资金流向',
      sizeRatio: sizeRatio,
      color: 'rgba(0,0,0,0.6)',
      fontFamily: familyM
    },
  },
  /*** 成交量 ***/
  Turnover: {
    fontFamily: familyM,
    sizeRatio: sizeRatio,
    color: 'rgba(0,0,0,0.6)'
  },
  /*** KDJ ***/
  KDJ: {
    axisY: {
      sizeRatio: sizeRatio,
      fontFamily: familyM,
      color: '#969696'
    },
    params: {
      color: "#999",
      index: 'KDJ(9,3,3)'
    },
    k: {
      lineWidth: 1,
      color: "#3896FF",
      sizeRatio: sizeRatio,
      fontFamily: familyM
    },
    d: {
      lineWidth: 1,
      color: "#F95EB8",
      sizeRatio: sizeRatio,
      fontFamily: familyM
    },
    j: {
      lineWidth: 1,
      color: "#FF8A00",
      sizeRatio: sizeRatio,
      fontFamily: familyM
    },
    space: 6
  },
  /*** ENE ***/
  ENE: {
    axisY: {
      sizeRatio: sizeRatio,
      fontFamily: familyM,
      color: '#969696'
    },
    upper: {
      lineWidth: 1,
      color: "#3896FF",
      sizeRatio: sizeRatio,
      fontFamily: familyM
    },
    lower: {
      lineWidth: 1,
      color: "#F95EB8",
      sizeRatio: sizeRatio,
      fontFamily: familyM
    },
    ene: {
      lineWidth: 1,
      color: "#FF8A00",
      sizeRatio: sizeRatio,
      fontFamily: familyM
    },
    space: 6
  },
  /*** MA5,MA10,MA20,MA30,MA60,MA120 ***/
  MA: {
    ma5: {
      sizeRatio: sizeRatio,
      lineWidth: 1,
      fontFamily: familyM,
      color: '#3896FF'
    },
    ma10: {
      sizeRatio: sizeRatio,
      lineWidth: 1,
      fontFamily: familyM,
      color: '#FF60F6'
    },
    ma20: {
      sizeRatio: sizeRatio,
      lineWidth: 1,
      fontFamily: familyM,
      color: '#FF8A00'
    },
    ma30: {
      sizeRatio: sizeRatio,
      lineWidth: 1,
      fontFamily: familyM,
      color: '#08B908'
    },
    ma60: {
      sizeRatio: sizeRatio,
      lineWidth: 1,
      fontFamily: familyM,
      color: '#09B8EF'
    },
    ma120: {
      sizeRatio: sizeRatio,
      lineWidth: 1,
      fontFamily: familyM,
      color: '#CA602A'
    },
    space: 6,
    arrowSpace: 3,
    arrowWidth: 6
  },
  BOLL: {
    axisY: {
      sizeRatio: sizeRatio,
      fontFamily: familyM,
      color: '#969696'
    },
    upper: {
      lineWidth: 1,
      color: "#3896FF",
      sizeRatio: sizeRatio,
      fontFamily: familyM
    },
    lower: {
      lineWidth: 1,
      color: "#F95EB8",
      sizeRatio: sizeRatio,
      fontFamily: familyM
    },
    mid: {
      lineWidth: 1,
      color: "#FF8A00",
      sizeRatio: sizeRatio,
      fontFamily: familyM
    },
    space: 6,
    arrowSpace: 3,
    arrowWidth: 6
  },
  /*** KD ***/
  KD: {
    width: 12,
    height: 12,
    triangleWidth: 2,
    verticalSpace: 6,
    radius: 1,
    fontFamily: familyM,
    sizeRatio: 0.8,
    k: {
      color: '#ffffff',
      backColor: '#36B48A',
      text: 'K'
    },
    d: {
      color: '#ffffff',
      backColor: '#FF4646',
      text: 'D'
    }
  },
  /*** 鲸奇9转 ***/
  JQJZ: {
    width: 11,
    height: 13,
    triangleWidth: 2,
    verticalSpace: 6,
    radius: 1,
    sizeRatio: sizeRatio,
    fontFamily: familyM,
    fall: {
      color: '#ffffff',
      backColor: '#36B48A',
    },
    rise: {
      color: '#ffffff',
      backColor: '#FF4646',
    }
  },
  /*** 晓鲸电波 ***/
  XJDB: {
    width: 20,
    sizeRatio: sizeRatio,
    fontFamily: familyM,
    color: '#969696',
    lineWidth: 0.5,
    text: '晓鲸电波',
    noAuth: {
      text: '晓鲸电波',
      sizeRatio: sizeRatio,
      fontFamily: familyM,
      color: '#000',
    }
  },
  /*** 成交饼图 ***/
  VolumnPie: {
    large_amount_in: "#FF4747",
    medium_amount_in: "#FF6B6B",
    little_amount_in: "#FF9999",
    large_amount_out: "#36B48A",
    medium_amount_out: "#52CCA3",
    little_amount_out: "#70E0BB",
    sizeRatio: 1,
    fontFamily: familyM,
  },
  Content: {
    drawTitle: true, // 是否绘制视图的标题
  }
};
export const setConfig = (obj) => {
  if (!Util.isObject(obj)) return;
  mergeOption(Conf, obj);
}

